import { queryOptions, useQuery } from '@tanstack/react-query';

import { diamondsApi } from '../api/diamonds-api';

import { diamondKeys } from './diamond-keys';

export function suppliersQueryOptions() {
  return queryOptions({
    queryKey: diamondKeys.suppliers(),
    queryFn: () => diamondsApi.suppliers(),
  });
}

/** A short, bounded list: every supplier in one `{ items }` answer. */
export function useSuppliers() {
  return useQuery(suppliersQueryOptions());
}
